<template>
  <div class="w-full">
    <Modal v-model="props.isModal" containerClass="w-1/2">
      <template #container>
        <div class="w-full flex flex-col">
          <div
            class="p-[15px] border border-b border-brand-gray-250 rounded flex justify-between items-center"
          >
            <span class="text-xl font-semibold text-gray-500">{{
              $t('pleaseSelectDepartment')
            }}</span>
            <faTimesIcon class="w-3 text-brand-gray-250" @click="close" />
          </div>
          <div class="w-full p-[15px]">
            <table class="w-full h-full mb-[20px] border borders border-brand-gray-250">
              <tbody>
                <tr
                  class="flex p-2 hover:bg-brand-100 cursor-pointer"
                  @click.prevent="selectedDepartment"
                >
                  <td>
                    {{ servicesData?.immigrationDepartment?.admninstrativeRegion?.text }} -
                    {{ servicesData?.immigrationDepartment?.text }} - {{ servicesData?.sponsorType?.text }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script setup>
import Modal from '@/components/Ui/Modal/index.vue'
import faTimesIcon from '@/assets/icons/faTimes.svg?component'
import { onMounted, onUnmounted } from 'vue'

const emits = defineEmits(['select', 'close'])

const props = defineProps({
  isModal: {
    type: Boolean,
    default: () => false
  },
  servicesData: {
    servicesData: Array,
    default: () => []
  }
})

const handleOverlayClick = () => {
  emits('close')
}

onMounted(() => {
  if (props.isModal === true) {
    document.addEventListener('click', handleOverlayClick)
  }
})

onUnmounted(() => {
  if (props.isModal === true) {
    document.removeEventListener('click', handleOverlayClick)
  }
})

const selectedDepartment = () => {
  emits('select', props.servicesData)
}

const close = () => {
  emits('close')
}
</script>

<style>
</style>